import React from 'react';
import PropTypes from 'prop-types';
import ReactWebsocket from 'react-websocket';

function getUrl(path) {
    // noinspection JSUnresolvedReference
    const port = (webpackMode === 'development') ? '8001' : location.port;
    const protocol = (location.protocol === 'http:') ? 'ws:' : 'wss:';
    return `${protocol}//${location.hostname}:${port}${path}`;
}

const Websocket = (props) => {
    return (
        <ReactWebsocket url={getUrl(props.path)} {...props}/>
    );
};

Websocket.propTypes = {
    path: PropTypes.string.isRequired,
};

export default Websocket;
